// Auth API wrappers — plan §4.1.2 (forgot/reset) + §4.1.3 (first-login).
// Backend route'ları için shared Zod request type'larını kullanır.

import type { ActivationStatusResponse, LoginResponse } from "@mahir/shared";
import { api } from "./client";

export interface ForgotResponse {
  ok: true;
  message: string;
}

export interface ResetResponse {
  user: {
    id: string;
    email: string;
    fullName: string;
  };
  message: string;
}

export async function forgotPassword(email: string): Promise<ForgotResponse> {
  return api<ForgotResponse>("/auth/forgot", {
    method: "POST",
    body: { email },
  });
}

export async function resetPassword(token: string, password: string): Promise<ResetResponse> {
  return api<ResetResponse>("/auth/reset", {
    method: "POST",
    body: { token, password },
  });
}

// First-login response == LoginResponse (BE auto-login yapıyor, CSRF token döner)
export async function firstLogin(token: string, password: string): Promise<LoginResponse> {
  return api<LoginResponse>("/auth/first-login", {
    method: "POST",
    body: { token, password },
  });
}

// Davet/sıfırlama bağlantısı ön kontrolü (2026-10-20) — sayfa açılırken çağrılır; hesap bilgisi
// dönmez. POST + gövde: token sorgu dizesinde sunucu/proxy erişim loglarına düşerdi. CSRF skip
// listesinde (oturum yok). Çağıran taraf hata durumunda formu gösterir (fail-open).
export async function getActivationStatus(token: string): Promise<ActivationStatusResponse> {
  return api<ActivationStatusResponse>("/auth/activation-status", {
    method: "POST",
    body: { token },
  });
}
